import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { useIsMobile } from '@hooks/use-is-mobile'

import { SidebarProvider, SidebarTrigger } from '@shadcn/sidebar'

import { querySession } from '@api/session/session.queries'

import GlobalSearch from '@/components/global-search/global-search'

import { AppSidebar } from './-components/app-sidebar'

export const Route = createFileRoute('/app')({
  component: RouteComponent,
  // Route requires a session
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData(querySession())
    } catch (error) {
      throw redirect({ to: '/session/login' })
    }
  },
})

function RouteComponent() {
  const isMobile = useIsMobile()

  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="bg-bg-active-50 flex w-full overflow-x-hidden">
        <Outlet />
      </main>
      {isMobile && <SidebarTrigger className="fixed top-2 left-2" />}
      <GlobalSearch />
    </SidebarProvider>
  )
}
